import { Box, Skeleton, Typography } from '@mui/material';
import { CustomChip } from 'src/shared/components/organisms/customChip';

type StatisticsContentHeaderProps = {
  isLoading?: boolean;
  title: string;
  subtitle?: string | undefined;
  subtitleComponent?: React.ReactNode;
  endEndornment?: 'kr' | 'st';
  badge?: string;
};

export const StatisticsContentHeader = (props: StatisticsContentHeaderProps) => {
  const { isLoading = false, title, subtitle = '', subtitleComponent, endEndornment = undefined, badge = undefined } = props;
  return (
    <>
      {isLoading ? (
        <>
          <Skeleton variant='text' animation='wave' sx={{ height: '28px', width: '50%' }} />
          <Skeleton variant='text' animation='wave' sx={{ height: '42px', width: '60%' }} />
        </>
      ) : (
        <>
          <Typography color='textSecondary'>{title}</Typography>
          <Box display='flex' justifyContent='start' alignItems='center'>
            {subtitleComponent ?? (
              <Typography sx={{ display: 'inline' }} variant='h4' fontWeight={(thm) => thm.typography.fontWeightBold}>
                {subtitle}
                {endEndornment && (
                  <Typography sx={{ display: 'inline' }} color='textSecondary' variant='h5' component='span'>
                    {!isLoading && <>{` ${endEndornment}`}</>}
                  </Typography>
                )}
              </Typography>
            )}

            {badge && (
              <Box ml={2}>
                <CustomChip label={badge} size='small' color='success' />
              </Box>
            )}
          </Box>
        </>
      )}
    </>
  );
};
